<tr class="row-edit" [formGroup]="taskForm" (appClickOutside)="clickedOutside($event)"
    [ngClass]="{'patient-task-disabled': !task.isActive}"
>
    @if (coloringTaskFeatureEnabled | async) {
        <td class="flex-2"></td>
    }
    <td class="flex-4">
        <span appTitleProvider>{{ task.taskDescription }}</span>
    </td>
    <td class="flex-9 pl-0">
        <app-time-picker
            [ngClass]="{
                'has-error':
                    taskForm.controls['fromTime'].errors || (taskForm.errors && taskForm.errors.dateAndTimeGreaterThanOrEqual)
            }"
            formControlName="fromTime"
            [disable]="saving"
            (change)="timeChanged()"
            (enterClick)="clickedOutside()"
            size="xsmall"
        ></app-time-picker>
        <span class="time-separator"></span>
        <app-time-picker
            [ngClass]="{
                'has-error': taskForm.controls['toTime'].errors || taskForm.errors?.dateAndTimeGreaterThanOrEqual
            }"
            formControlName="toTime"
            [disable]="saving"
            appCustomPopover
            [popoverTextValidation]="taskForm.errors?.dateAndTimeGreaterThanOrEqual ? 'TASK_END_TIME_VALIDATION' : ''"
            popoverType="error"
            (change)="timeChanged()"
            (enterClick)="clickedOutside()"
            size="xsmall"
        ></app-time-picker>
    </td>
    <td class="flex-4">
        <app-form-input
            class="pl-1"
            type="number"
            formControlName="duration"
            [error]="getTaskDurationError(taskForm)"
            [disable]="saving"
        ></app-form-input>
    </td>
    <td class="flex-5">
        <app-dropdown
            formControlName="shiftType"
            [items]="shiftTypeDropdownItems$ | async"
            [disable]="saving"
        ></app-dropdown>
    </td>
    <td class="flex-5">
        <app-dropdown
            formControlName="skillRequirement"
            [items]="skillLevelDropdownItems$ | async"
            [disable]="saving"
        ></app-dropdown>
    </td>
    <td class="flex-3">
        <app-dropdown
            formControlName="numberOfEmployees"
            [items]="numberOfEmployeesDropdownItems"
            [disable]="saving">
        </app-dropdown>
    </td>
    <td class="flex-3 justify-content-center">
        <app-toggle formControlName="permanent" class="w-100"
                    [id]="task.taskId" [large]="true" [disable]="saving">
        </app-toggle>
    </td>
    @if (breakPointValue >= BreakpointValue.LARGE) {
        <td class="flex-5 justify-content-center">
            @for (responsible of task.mainResponsibleEmployees | slice: 0:1; track responsible) {
                <span
                    class="responsible-initials"
                    [ngClass]="{ primary: responsible.primaryContact, secondary: responsible.secondaryContact }"
                >
                    {{ responsible.initials }}
                </span>
            }
            @if (task.mainResponsibleEmployees.length > 1) {
                <app-tooltip
                    appCustomPopover
                    [popoverText]="getHiddenInitials(task)"
                    placement="top"
                    [compact]="true"
                >
                    <ng-container icon>
                        <span class="responsible-initials"> +{{ task.mainResponsibleEmployees.length - 1 }} </span>
                    </ng-container>
                </app-tooltip>
            }
        </td>
    }
    <td class="flex-3 justify-content-center">
        <app-checkbox formControlName="isActive" class="w-auto mx-auto"></app-checkbox>
    </td>
    <td class="flex-4 justify-content-center">
        @if (!saving) {
            <app-tooltip title="{{'REVERT' | translate}}" [compact]="true" (click)="revert($event)">
                <ng-container icon>
          <span
              class="vismaicon vismaicon-sm vismaicon-refresh vismaicon-reverse mr-2"
              [ngClass]="{ disabled: taskForm.pristine }"
          ></span>
                </ng-container>
            </app-tooltip>
            <app-tooltip title="{{'SAVE' | translate}}" [delay]="2000" [compact]="true" (click)="save($event)">
                <ng-container icon>
          <span
              class="vismaicon vismaicon-sm vismaicon-save"
              [ngClass]="{ disabled: taskForm.pristine || taskForm.invalid }"
          ></span>
                </ng-container>
            </app-tooltip>
        }
        @if (saving) {
            <div class="spinner"></div>
        }
    </td>
    <td class="flex-4 justify-content-center"></td>
    <td class="flex-3">
        <app-feasibility-info [feasibilityInfo]="task.feasibilityInfo"></app-feasibility-info>
    </td>
</tr>
